import ShipPrice from './ShipPrice';

const Shipping = (props) => {
  const { shipping, settings } = props;
  return (
    <>
      {shipping.map((ship) => (
        <div key={ship.id}>
          <div>Shipping:</div>
          <ShipPrice shipping={ship} settings={settings} />
        </div>
      ))}
    </>
  );
};

export default Shipping;
